import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import LanguageDropdown from "../components/LanguageDropdown";
import { Outlet } from "react-router-dom";
import useUserInfo from "../hooks/useUserInfo";

const SidebarLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [selectedLanguage, setSelectedLanguage] = useState("NL");
  const { userInfo } = useUserInfo();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLanguageChange = (language: string) => {
    setSelectedLanguage(language);
  };

  const currentHour = new Date().getHours();
  let greeting = "";
  if (currentHour < 12) {
    greeting = "Goedemorgen";
  } else if (currentHour < 18) {
    greeting = "Goedemiddag";
  } else {
    greeting = "Goedenavond";
  }

  return (
    <div className="flex h-screen">
      <Sidebar isSidebarOpen={isSidebarOpen} />
      <div
        className={`flex-1 flex flex-col transition-all ${
          isSidebarOpen ? "ml-64" : "ml-0"
        }`}
      >
        <nav className="bg-white shadow-md p-4 flex items-center w-full">
          {/* Hamburger knop */}
          <button
            onClick={toggleSidebar}
            className="p-2 text-[#08111A] flex flex-col gap-1 focus:outline-none sm:flex"
          >
            <span className="block w-6 h-1 bg-[#08111A] rounded"></span>
            <span className="block w-6 h-1 bg-[#08111A] rounded"></span>
            <span className="block w-6 h-1 bg-[#08111A] rounded"></span>
          </button>

          {/* Gebruikersgroet */}
          <div className="flex items-center space-x-2 mx-auto">
            <span className="text-sm sm:text-lg font-semibold">
              {greeting},
            </span>
            <span className="text-md sm:text-xl font-bold">
              {userInfo.displayName}
            </span>
          </div>

          {/* Language dropdown */}
          {/* <LanguageDropdown
            selectedLanguage={selectedLanguage}
            onLanguageChange={handleLanguageChange}
          /> */}
        </nav>

        <main className="flex-1 p-4 bg-[#F4F5F9] overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SidebarLayout;
